export enum LocalStorageEnum {
    NonEssentialCookiesAllowed = 'nonEssentialCookiesAllowed',
    NonEssentialCookiesPreferenceExpiryDateTime = 'nonEssentialCookiesPreferenceExpiryDateTime'
}